import styled from 'styled-components';
import { DISTANCE_MEASUREMENT_MEDIUM } from 'HubStyleTokens/sizes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import H4 from 'UIComponents/elements/headings/H4';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PortalIdParser from 'PortalIdParser';
import { callingMarketplaceAppsUrl } from 'calling-lifecycle-internal/utils/urlUtils';
import getAppUrls from 'calling-orchestration-shared-library/constants/appUrls';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "GlobalCallingDisabled__Wrapper",
  componentId: "sc-1k8970l-0"
})(["display:flex;justify-content:center;align-self:center;padding:", ";max-width:500px;"], DISTANCE_MEASUREMENT_MEDIUM);
const SectionWrapper = styled.div.withConfig({
  displayName: "GlobalCallingDisabled__SectionWrapper",
  componentId: "sc-1k8970l-1"
})(["padding-left:", ";"], DISTANCE_MEASUREMENT_MEDIUM);
const portalId = PortalIdParser.get() || '';
function GlobalCallingDisabled() {
  const {
    callingConfigurationSettingsUrl
  } = getAppUrls();
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      name: "calling",
      width: "15%"
    }), /*#__PURE__*/_jsxs(SectionWrapper, {
      children: [/*#__PURE__*/_jsx(H4, {
        className: "m-bottom-2",
        "data-selenium-test": "calling-disabled-message",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "globalCallingDisabled.title"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "globalCallingDisabled.message_jsx",
          elements: {
            UILink
          },
          options: {
            settingsLinkProps: {
              href: callingConfigurationSettingsUrl
            },
            marketplaceLinkProps: {
              href: callingMarketplaceAppsUrl(portalId)
            }
          }
        })
      })]
    })]
  });
}
export default GlobalCallingDisabled;